<template>
  <div class="act">
    <!-- <img 
      src="@/assets/GuangzhouUnicomImg/new2/bg.png"
      class="act-bg"
      alt=""
    />
     -->
     <LogoHeader 
      :logoPath="require('@/assets/logo/elm/elm-mobile.png')"
      altText="中国移动Logo"
    />
    <img
      class="queryBtn"
      src="@/assets/GuangzhouUnicomImg/queryBtn.png"
      alt=""
      v-analytics="'queryOrder'"
      @click="queryOrder"
    />
    <img
      class="kefuBtn"
      src="@/assets/GuangzhouUnicomImg/service.png"
      alt=""
      @click="openKefu"
    />
    <div class="bottomBtn" v-show="bottomBtn">
      <img
        @click="onSubmit"
        class="bottomBtnImg"
        src="@/assets/GuangzhouUnicomImg/lqBtn.png"
        alt=""
      />
    </div>
    <div class="content">
      <img src="@/assets/ydtop.png" class="topImg" alt="" />
      <div class="contentBox1">
        <div class="container">
          <div class="header2">重要提醒</div>
          <div class="content">
            <p class="textIndent highlight">
              请保管好自己的身份证、手机卡，不要出租、出借、出售给他人。根据《中华人民共和国刑法》规定，对明知他人利用信息网络实施犯罪而提供帮助，情节严重的，处三年以下有期徒刑或拘役，并处或单处罚金。
            </p>
          </div>
        </div>
        <div class="container">
          <div class="header">套餐内容</div>
          
          <div class="content">
            <div class="zfxqTable3">
              <div class="zTr">
                <div class="zTh">原月租</div>
                <div class="zTd">
                  <span class="blueText">69元/月</span>
                </div>
                <div class="zTd">
                  <span class="blueText">69元/月</span>
                </div>
              </div>
              <div class="zTr">
                <div class="zTh">原套餐<br><span class="small">（通话享受优惠24个月）</span></div>
                <div class="zTd">
                  20GB国内通用流量<br />
                  30G国内定向<br/>
                  200条短信
                </div>
                <div class="zTd">
                  20GB国内通用流量<br />
                  30G国内定向<br/>
                  200条短信
                </div>
              </div>
              <div class="zTr">
                <div class="zTh">现月租<br><span class="small">（通话享受优惠24个月）</span></div>
                <div class="zTd">
                  <br>
                  <span class="blueText2">39元/月</span>
                </div>
                <div class="zTd">
                  <br>
                  <span class="blueText2">59元/月</span>
                </div>
              </div>             
              <div class="zTr">
                <div class="zTh">现套餐<br><span class="small">（通话享受优惠24个月）</span></div>
                <div class="zTd">
                  <div>
                  <strong class="blueText">2000分钟</strong><span style="font-size: 15px;">通话</span><br />
                  <span class="small">（24个月）</span><br />
                  </div>
                  <div style="padding-top:10px;">
                    <strong class="blueText" style="padding-top:20px;">100G</strong><span style="font-size: 15px;">流量</span><br>
                    <span class="small" style="color: #3e5fb2;">70G通用流量</span><br>
                    <span class="small">(20G通用流量+50G通用流量(24个月)</span><br />
                    <span class="small" style="color: #3e5fb2;">30G定向流量</span><br>
                  </div>
                  <div style="padding-top:10px;">
                    <strong class="blueText" >200条短信</strong>
                  </div>
                </div>
                <div class="zTd">
                  <div>
                    <strong class="blueText">2500分钟</strong><span style="font-size: 15px;">通话</span><br />
                    <span class="small">（24个月）</span><br />
                  </div>
                  <div style="padding-top:10px;">
                    <strong class="blueText" style="padding-top: 20px;">130G</strong>流量<br>
                    <span class="small" style="color: #3e5fb2;">100G通用流量</span><br>
                    <span class="small">(20G通用流量+80G通用流量(24个月)</span><br />
                    <span class="small" style="color: #3e5fb2;">30G定向流量</span><br>
                  </div>
                  <div style="padding-top:10px;"><strong class="blueText" >200条短信</strong></div>
                </div>
              </div>
              <div class="zTr">
                <div class="zTh">到期后</div>
                <div class="z3Td">
                  <div>
                    优惠期24个月后恢复原价69元/月，套餐为20G国内通用流量+30G定向流量+200条短信
                  </div>
                </div>
              </div>
              <div class="zTr">
                <div class="zTh">套餐外资费</div>
                <div class="z3Td">
                  <div>
                    <strong>国内主叫：</strong>0.1元/分钟<br>
                    <strong>短信：</strong> 0.1元/条<br>
                    <strong>彩信：</strong>0.3元/条<br>
                    <strong>流量：</strong>5元/GB
                  </div>
                </div>
              </div>
              <div class="zTr">
                <div class="zTh">额外说明</div>
                <div class="z3Td">
                  <div>您办理的优惠存在24个月合约期，合约期内，客
                    户如办理过户、停机、销户、离网、营销活动中断
                    等业务，视为违约。对于合约期内尚未享受的优
                    惠将不再享受，同时客户需按照解约条款的“已
                    获赠业务进行价值折算金额”作为协议终止违约
                    金。退订和解约条款参照中国移动通信客户业务
                    解约条款<br>
                    <a href="https://dx.10086.cn/3DHGAQ">https://dx.10086.cn/3DHGAQ</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="contentBox2">
        <div class="userInfo">
          <van-form @submit="onSubmit" :label-width="0">
            <div class="form-item">
              <div class="form-label form-label__reqiured">套餐</div>
              <van-field
                class="form-field"
                v-model="comboName"
                name="cardName"
                placeholder="请选择套餐"
                readonly
                @click="showTCBox"
              />
              <van-popup v-model="tcShow" position="bottom">
                <div class="tcBox">
                  <div class="topBox">
                    <!-- <div class="close" @click="closeTC">取消</div>
                    <div class="define" @click="defineTC">确定</div> -->
                    <van-icon name="cross" size="24px" color="#999" @click="closeTC"/>
                  </div>
                  <div class="content">
                    <div
                      :class="['tcItem', { active: index == selIndex }]"
                      v-for="(item, index) in tcList"
                      :key="index"
                      @click="changeTC(index)"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </van-popup>
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">姓名</div>
              <van-field
                class="form-field"
                v-model="cardName"
                name="cardName"
                placeholder="与身份证一致（已加密）"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">身份证号</div>
              <van-field
                class="form-field"
                v-model="cardNo"
                name="cardNo"
                maxlength="18"
                placeholder="仅用于本次业务（已加密）"
                :rules="[
                  {
                    validator: sfzValidator,
                    message: '请输入正确身份证号码',
                  },
                ]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">联系电话</div>
              <van-field
                class="form-field"
                v-model="contactsMobile"
                maxlength="11"
                name="contactsMobile"
                placeholder="收货手机号码（已加密）"
                :rules="[{ pattern, message: '请输入正确手机号码' }]"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="请选择归属地区省市"
                @click="showAttributionPicker = true"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">收货城市</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="contactsCity"
                :value="contactsCity"
                placeholder="请选择收货省市区"
                @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList"
                  @confirm="onConfirm"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">详细地址</div>
              <van-field
                class="form-field"
                v-model="contactsAddress"
                name="contactsAddress"
                placeholder="请输入详细的收货地址"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">免费选号</div>
              <van-field
                readonly
                clickable
                class="form-field"
                :value="comboMobile"
                name="comboMobile"
                placeholder="请选择号码"
                @click="numGuessSelect()"
              />
              <van-dialog
                v-model="showMobilePicker"
                :showConfirmButton="false"
                class="numDialog"
              >
                <div class="numClose">
                  <van-icon
                    name="close"
                    @click="showMobilePicker = false"
                    size="1.2rem"
                  />
                </div>
                <div class="numBox">
                  <div
                    v-for="item in numList"
                    :key="item"
                    class="numContent"
                    @click="selcetNum(item)"
                  >
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="numBtn">
                  <van-button
                    icon="replay"
                    type="default"
                    native-type="button"
                    @click="numGuessSelect()"
                    >换一换</van-button
                  >
                </div>
              </van-dialog>
            </div>
            <div class="form-item" v-if="zpActivety">
              <div class="form-label form-label__reqiured">
                {{ simSpiActivity.giftAttrName }}
              </div>
              <van-field
                v-if="sizeList.length <= 1"
                class="form-field"
                :value="giftInfo"
                name="contactsAddress"
                placeholder="请选择赠品尺码"
              />
              <select
                v-else
                class="selectBox"
                v-model="giftInfo"
                @change="changeSize"
              >
                <option value="" disabled selected>请选择尺码</option>
                <option v-for="(item, index) in sizeList" :key="index">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="activeInfo" v-if="zpActivety">
              <div class="activeLeft">{{ simSpiActivity.tips }}</div>
              <div class="activeRight" @click="openTips">
                活动说明
                <van-icon name="question-o" />
              </div>
            </div>
            <div
              class="dealText"
              v-if="dealTextList && dealTextList.length > 0"
            >
              <div class="read">
                <van-checkbox v-model="checkDeal" icon-size="16px" />
                我已阅读并同意
                <span
                  class="deal"
                  @click="toUnicomDeal(item.components)"
                  v-for="(item, index) in dealTextList"
                  :key="index"
                  ><span class="xy">《{{ item.name }}》</span>
                  <!-- {{ index == dealTextList.length - 1 ? "" : "、" }} -->
                </span>
              </div>
            </div>
          </van-form>
          <div class="btn" ref="sumitBtm" @click="onSubmit">
            <img
              class="lqBtn"
              src="@/assets/GuangzhouUnicomImg/lqBtn.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="bmInfo">
          <div class="bmTitle">最新报名用户</div>
          <div class="bmContent">
            <vue-seamless-scroll
              class="scroll-content"
              :class-option="classOption"
              :data="winningList"
            >
              <div
                class="bmItem"
                v-for="(item, index) in winningList"
                :key="index"
              >
                <div class="bmItemName">{{ item.name }}</div>
                <div class="bmItemPhone">{{ item.phone }}</div>
                <div class="bmItemTime">{{ item.time }}分钟前</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- <div class="tcysInfo">
          <img
            class="tcysImg"
            src="@/assets/GuangzhouUnicomImg/new2/tcys.png"
            alt=""
          />
        </div> -->

        <div class="container">
          <div class="header">详细说明</div>
          <div class="content">
            <div class="section">
              <!-- <h3>详细说明：</h3> -->
              <p>
                1、套内通用流量长期有效，月结日套内未用完通用流量可结转至次月，不可参与流量转赠；额外获得的广东区域流量仅限当月使用，不可结转/转赠，仅限广东省范围内使用，优惠期24个月，到期自动取消。国内定向流量长期有效，不可结转、转赠。新入网客户办理基础套餐，激活后即生效，生效即扣取当月套餐费用。
              </p>
              <p>  
                2、套餐所含通话为国内拨打国内通话分钟数（含超清视频通话），国内接听免费，套餐内包含来电显示业务。
              </p>
              <p>
                3、数据流量封顶规则：基于公平使用原则，流量费用600元（不含套餐费）,将暂停上网功能，次月自动恢复，客户当月可主动申请打开上网功能，上网功能打开后按套外资费标准收费。
              </p>
              <p>
                4、本产品采用动态月结方式，即:激活开通当日即为初始月结日。以后每月月结日，系统将从账户划扣本月套餐费用，若月结日在下月无此日(如2021年2月29日)，则下月扣取日改为下月最后一天(如2021年2月28日)，并以此日作为新的月结日。
              </p>
              <p>
                5、套餐内所含的40GB中国移动云盘服务（含20GB个人云+20GB家庭云）请下载登录中国移动云盘APP使用。
              </p>
              <p>
                6、以上未特别说明，国内通话、流量、短彩信资费均不适用于中国港澳台地区。
              </p>
              <p>
                7、本卡品不支持办理万能副卡。
              </p>
              <p>
                8、您办理的套餐存在24个月合约期，在合约优惠期间，客户需保持使用移动网络及当前套餐档次24个月；如打算提前结束优惠，需前往服务厅办理解约手续，且需要交纳赔付金。赔付金额按月赔付，优惠一、优惠二根据3种资费按已履行完月份*30/210元/月或*10/310元/月或*350元/月向我司支付违约金。
              </p>
              <p>
                9、以上优惠适用于骑手日常工作，若暂停、注销职业身份,改换平台或职业身份异常状态下,运营商将会停止专属叠加包优惠；若出现疑似诈骗和骚扰电话行为的,运营商有权对号码停止专属叠加包优惠或采取保护性服务限制措施，并将实名信息转交公安部门处理。
              </p>
            </div>

            
          </div>

        </div>

        <div class="container">
          <div class="header">购买须知</div>
          <div class="content">
            <div class="section">
              <p>
                1、客户下单购买需年满18周岁并且有民事行为能力，同一身份证在一定期限内（一般为90天）只能办理1个号码，具体限制时间以号码归属地政策为准。
              </p>
              <p> 2、为了保障通讯秩序，我司有权取消异常订单。如同一用户订购两个或两个以上相同商品的订单，不予发货。同一用户的定义包括但不限于以下情况:同一身份证、或同一联系号码、或同一个收件人(同名除外)、相同(雷同、邻近、虚构、乱码等)的收货地址等。
              </p>
              <p>3、根据国家实名制相关规定，请保证所购号卡为本人使用，不得转售、倒卖号卡。
              </p>
              <p>4、若客户提供的资料不真实或存在其他法律障碍，我司有权随时暂停服务，并解除本协议及本协议有效期内与客户签订的任何协议。
              </p>
              <p>5、根据公安部和工信部要求，新入网客户呼叫转移功能处于关停状态。
              </p>
              <p>6、为保障您的合法权益，购买号卡产品必须由使用者本人亲自签收，并向配送人员出示身份证原件，不支持代收，否则我司有权拒绝交付。
              </p>
              <p>7、配送说明:本产品由合作的快递公司配送，具体派送情况，请以物流信息及配送结果为准，部分地址可能无法配送。
              </p>
              <p>8、号码归属地：广东广州，按选择配送。
               </p>
              <p>9、其它未尽事宜，详询10086。
              </p>
            </div>
          </div>
        </div>

        <div class="container">
          <div class="header">常见问题</div>
          <div class="content">
            <div class="section">
              <p>1、未满18周岁不能办理新卡入网。</p>
              <p>
                2、请于提交订单15天内激活您的号卡，逾期未能激活的，本订单将自动取消，号卡失效。
              </p>
              <p>
                3、根据工信部要求，您的号卡激活且开通后将由人工对实名照片进行审核，审核不通过的将通过短信方式通知您按要求进行补上传照片操作，逾期若未补上传照片的，号码将被暂停通信服务。
              </p>
              <p>4、50天内已超过3次办理移动号卡拆机业务的用户无法办理此卡。</p>
              <p>5、本套餐不支持副卡。</p>
              <p class="textIndent">套餐条款以页面营销协议为准</p>
              <p>
                6、此卡禁止用于电话销售/推销/金融等类似骚扰诈骗等形式的用途，一旦被投诉或系统监测到会导致停机，无法继续享受优惠或使用。
              </p>
              <p>
                7、产品及相关优惠活动仅限指定互联网渠道销售，产品最终名称以移动系统展示为准。在使用过程中若遇任何问题，可致电18594033399/17502020112客服热线咨询。
              </p>
              <p>8、如需销户，可咨询归属地10086</p>
            </div>
          </div>
        </div>
        <div class="container">
          <img
            class="spiImg"
            src="@/assets/chinamobileImg/yd-gz-img.jpg"
            alt=""
          />
        </div>
      </div>

      <img
        class="bottomImg"
        src="@/assets/GuangzhouUnicomImg/bottomImg.png"
        alt=""
      />
    </div>
    <van-dialog
      v-model="showKefu"
      title="扫码联系客服"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
    >
      <div class="kefuBox">
        <!-- <img
          class="kefuQRCode"
          src="@/assets/GuangzhouUnicomImg/new/kefuQRCode.png"
          alt=""
        /> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSetSize"
      title="赠品尺码"
      confirm-button-text="确定"
      confirm-button-color="#3860cf"
      @confirm="confirmSize"
    >
      <div class="sizeBox">
        <div class="sizeBoxList">
          <div
            :class="['sItem', { active: index == sizeIndex }]"
            @click="changeSize(index)"
            v-for="(item, index) in sizeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="tipsShow"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
      @confirm="closeTips"
    >
      <div class="dialogTips">
        <img class="tipsImg" :src="tipsImg" alt="" />
      </div>
    </van-dialog>
    <dialogTips
      :text="dialogTips.text"
      :icon="dialogTips.icon"
      :iconColor="dialogTips.iconColor"
      :show="dialogTips.show"
      :confirmButtonText="dialogTips.confirmButtonText"
      @confirm="confirmTips"
    ></dialogTips>
    <van-dialog
      v-model="showAttributionPicker"
      title="请选择号码归属地"
      :show-confirm-button="false"
      :show-cancel-button="false"
      class="attribution-dialog"
    >
      <div class="attribution-content">
        <div class="city-list">
          <div 
            v-for="(city, index) in cardAreaData.children" 
            :key="index"
            class="city-item"
            @click="handleCitySelect(city)"
          >
            {{ city.text }}
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  Form,
  Field,
  Popup,
  Picker,
  Dialog,
  Icon,
  Checkbox,
  Button,
} from "vant";
import areaData from "../../public/static/areaData.json";
// import operatorData from "../../public/static/operatorData.json";
import { http } from "@/api/http";
import moment from "moment";
import dialogTips from "@/pages/components/dialogTips";
import LogoHeader from "@/components/LogoHeader.vue";
// import Countdown from "./components/Countdown.vue";
// import { deepClone } from "@/utils/utils";
export default {
  name: "GuangzhouMobile1",
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button,
    vanIcon: Icon,
    vanCheckbox: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    dialogTips,
    LogoHeader,
    // Countdown,
  },
  data() {
    return {
      areaList: [],
      comboName: "",
      cardName: "",
      cardNo: "",
      contactsMobile: "",
      cardAttribution: "",
      cardAttributionCode: "",
      comboMobile: "",
      contactsCity: "",
      contactsAddress: "",
      columns: [],
      showArea: false,
      showMobile: "",
      checkDeal: false,
      showPicker: false,
      showAttributionPicker: false,
      // mapData: [],
      mtBmUid: "",
      spiId: "",
      cardAttributionProvince: "",
      showMobilePicker: false,
      numList: [],
      pattern: /^1[3456789]\d{9}$/,
      // selectCombo: {},
      goodsCode: null,
      dealTextList: [], //协议数据
      areaData: {},
      areaData2: {}, //号码归属地
      saleId: null,
      scrollY: 0,
      bottomBtn: false,
      showBtnTop: 0,
      oIndex: 0,
      comboData: {},
      channel: "",
      winningList: [
        { name: "张**", phone: "137******3", time: 5 },
        { name: "李**", phone: "138******6", time: 7 },
        { name: "欧阳**", phone: "170******1", time: 7 },
        { name: "陈**", phone: "182******6", time: 9 },
        { name: "林**", phone: "187******3", time: 10 },
        { name: "张**", phone: "153******2", time: 10 },
        { name: "黄**", phone: "138******5", time: 11 },
        { name: "王**", phone: "136******1", time: 12 },
        { name: "李**", phone: "182******7", time: 12 },
        { name: "陈**", phone: "189******8", time: 13 },

        // 更多中奖者...
      ],
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      showKefu: false,
      endTime: moment("2024/12/25 09:59:59").valueOf(),
      isEnded: false,
      sizeList: [],
      showSetSize: false,
      giftInfo: "",
      sizeIndex: 0,
      zpActivety: false,
      simSpiActivity: null,
      tipsShow: false,
      tipsImg: "",
      dialogTips: {
        text: "",
        icon: "",
        iconColor: "",
        show: false,
        confirmButtonText: "",
      },
      noClick: false,
      goodsName: "",
      selNumTips: "请选择号码",
      tcShow: false,
      selIndex: -1,
      tcList: [
        {
          name: "优享骑手卡39元/月2000分钟+100G",
          title: "GZYD-ELM39",
          comboCode: "GZYD-ELM39",
          goodsCode: "GZYD-ELM39",
          price: 39,
        },
        {
          name: "尊享骑手卡59元/月2500分钟+130G",
          title: "GZYD-ELM59",
          comboCode: "GZYD-ELM59",
          goodsCode: "GZYD-ELM59",
          price: 59,
        }
      ],
      comboCode: "",
      //号卡归属省市
      cardAreaData: {
        text: "",
        code: "0",
        children: [
          {
            text: "广州市",
            code: "440100"
          },
          {
            text: "深圳市",
            code: "440300"
          },
          {
            text: "珠海市",
            code: "440400"
          },
          {
            text: "佛山市",
            code: "440600"
          },
          {
            text: "东莞市",
            code: "441900"
          }
        ]
      }
    };
  },
  created() {
    this.mtBmUid = localStorage.getItem("mtBmUid");
    this.spiId = localStorage.getItem("gysCode");
    this.saleId = localStorage.getItem("saleId");
    this.oIndex = localStorage.getItem("oIndex");
    this.channel = localStorage.getItem("channel");
    console.log("this.channel =>", this.channel);
    this.areaList = [];
    this.areaList.push(areaData["440000"]);
    // this.areaList.push(areaData["guangzhouyidong"]);
    this.initAreaList2();
    // 默认不设置归属地，让用户选择
    // this.cardAttribution = "广东广州";
    // this.cardAttributionProvince = "440000";
    // this.cardAttributionCode = "440100";
    // this.comboData = {
    //   comboLevel: 39,
    //   abstractImg: "",
    //   comboName: "29元/月骑手卡套餐",
    //   showMobile: "true",
    //   goodsCode: this.oIndex,
    //   comboCode: this.oIndex,
    // };

    // this.comboName = this.comboData.comboName;
    // this.goodsName = this.comboData.comboName;
    this.dealTextList = [
      {
        name: "入网协议",
        components: "gdydruwangxy",
        },
        {
          name: "用户隐私协议",
          components: "gdydyhxsxy",
        },
        {
          name: "电子渠道开户服务协议",
          components: "gddzqdkhfwxy",
        },{
          name: "中国移动广东公司电子渠道商品销售服务协议",
          components: "gdyddzqdspxsfwxy",
        },{
          name: "个人/单位在通信企业申请通讯工具涉电信网络新型违法犯罪法律责任及防范提示告知书",
          components: "gdydtxqysqtxgjsdxwlxxwffzflzrjfftsgzs",
        },{
          name: "中国移动权益超市服务协议",
          components: "gdydqycsfwxy",
        },{
          name: "解约条款",
          components: "gdydjytk",
        }
    ];
    this.simViewLogAdd();
    if (this.channel == "ELM") {
      this.getActivityBySpi();
    }
    // 页面加载时自动弹出归属地选择器
    // this.$nextTick(() => {
    //   this.showAttributionPicker = true;
    // });
    let city = {"code": "440100", "text": "广州市"}
    this.handleCitySelect(city);
  },
  watch: {
    selIndex(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.comboMobile = "";
        this.comboName = this.tcList[newVal].name;
        this.goodsName = this.tcList[newVal].name;
      }
    },
    // cardAttribution(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.comboMobile = "";
    //   }
    // },
    // cardAttribution(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.comboMobile = "";
    //     let obj = {};
    //     let arr = [];
    //     console.log("newVal =>", newVal);
    //     if (newVal.includes("西藏") || newVal.includes("新疆")) {
    //       if (newVal.includes("西藏")) {
    //         obj = deepClone(areaData["540000"]);
    //       } else if (newVal.includes("新疆")) {
    //         obj = deepClone(areaData["650000"]);
    //       }
    //       this.contactsCity = "";
    //       this.areaData = [];
    //     } else {
    //       obj = deepClone(areaData["gzuni0000000001"]);
    //     }
    //     arr.push(obj);
    //     this.areaList = arr;
    //     console.log("areaList =>", this.areaList);
    //   }
    // },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      const height = this.$refs.sumitBtm.offsetTop;
      this.showBtnTop = height + window.innerHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    changeTC(index) {
      this.selIndex = index;
      this.tcShow = false;
    },
    showTCBox() {
      this.tcShow = true;
    },
  
    closeTC() {
      this.tcShow = false;
    },

    confirmTips() {
      this.dialogTips.show = false;
      this.$forceUpdate();
      if (this.dialogTips.icon == "success") {
        window.location.reload();
      }
    },
    openTips() {
      this.tipsImg = this.simSpiActivity.imgPath;
      // console.log("tipsImg =>",this.tipsImg)
      this.tipsShow = true;
    },
    closeTips() {
      this.tipsShow = false;
    },
    async simViewLogAdd() {
      let params = {
        mtBmUid: this.oIndex,
        spiId: this.spiId,
        clickName: this.oIndex,
        uid: "",
      };
      http("simViewLogAdd", params);
    },
    errorAdd(msg, remark, params) {
      let newParams = {
        mtBmUid: this.oIndex,
        spiId: this.spiId,
        clickName: `ERROR-${this.oIndex}-${msg}`,
        uid: params.contactsMobile,
        remark,
        param: JSON.stringify(params),
      };
      http("simViewLogAdd", newParams);
    },
    confirmSize() {
      this.giftInfo = this.sizeList[this.sizeIndex].value;
    },
    setSize(item) {
      this.giftInfo = item.value;
    },
    changeSize(e) {
      console.log("e =>", e.target.value);
      this.giftInfo = e.target.value;
      // this.sizeIndex = index;
    },
    openSetMeal() {
      this.showSetSize = true;
    },
    ended() {
      this.isEnded = true;
    },
    openKefu() {
      // this.showKefu = true;
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc2ef46aff0a7d85a6";
    },
    queryOrder() {
      window.location.href = "https://wap.gd.10086.cn/ncc/web/h5/#/myOrder";
    },
    async getActivityBySpi() {
      let params = {
        spiId: this.spiId,
      };

      const res = await http("getActivityBySpi", params, { hideLoading: true });
      console.log("res=>", res);
      if (res && res.code == 200 && res.result.hasActivity) {
        let list = [];
        let sList = JSON.parse(res.result.simSpiActivity.giftSelectList);
        let obj = null;
        sList.map((v) => {
          for (let key in v) {
            obj = {
              name: key,
              value: v[key],
            };
          }
          list.push(obj);
        });
        if (list.length <= 1) {
          this.giftInfo = list[0].value;
        }
        this.sizeList = list;
        this.simSpiActivity = res.result.simSpiActivity;
        this.zpActivety = true;
        this.tipsImg = res.result.simSpiActivity.imgAlertPath;
        this.tipsShow = true;
      } else {
        this.zpActivety = false;
      }
    },
    async onSubmit(values) {
      if (this.noClick) {
        return;
      } else if (!this.checkDeal) {
        this.$toast("请阅读并同意协议");
        return;
      } else if (!this.comboName) {
        this.$toast("请选择套餐");
        return;
      } else if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }
       else if (!this.comboMobile) {
        this.$toast("请选择号码");
        return;
      }
      else if (!this.contactsCity) {
        this.$toast("请选择收货区地址");
        return;
      } else if (!this.contactsAddress) {
        this.$toast("请输入详细的收货地址");
        return;
      } else if (this.contactsAddress.length < 4) {
        this.$toast("详细地址长度不少于4位");
        return;
      } else if (this.zpActivety && !this.giftInfo) {
        this.$toast("请选择赠品尺码");
        return;
      }

      let params = {
        comboLevel: this.tcList[this.selIndex].price,
        comboName: this.tcList[this.selIndex].name,
        cardAttribution: this.cardAttributionCode,
        goodsName: this.goodsName,
        mtBmUid: this.mtBmUid,
        spiDepartId: this.spiId,
        comboMobile: this.comboMobile,
        cardAttributionProvince:this.cardAttributionProvince,
        contactsProvince: this.areaData.pName, // 省
        contactsProvinceCode: this.areaData.pCode, // 省
        contactsCity: this.areaData.cName, // 市
        contactsCityCode: this.areaData.cCode, // 市
        contactsArea: this.areaData.aName, // 区
        contactsAreaCode: this.areaData.aCode, // 区
        comboCode: this.tcList[this.selIndex].comboCode,
        goodsCode: this.tcList[this.selIndex].goodsCode,
        saleId: this.saleId,
        cardName: this.cardName,
        cardNo: this.cardNo,
        channelCode: "",
        checkCode: "",
        contactsAddress: this.contactsAddress,
        contactsMobile: this.contactsMobile,
        feeType: "",
        numberId: "",
        registerMobile: "",
        tractAddress: "",
        uid: "",
        channel: this.channel,
      };
      // if (this.areaData2.pCode != this.areaData.pCode) {
      //   this.errorAdd("GSDSHDZBYZ", "号码归属省份和收货省份不一致", params);
      //   return this.$toast("号码归属省份需和收货省份一致");
      // }
      if (this.zpActivety) {
        params = {
          ...params,
          giftInfo: this.giftInfo,
        };
      }
      this.noClick = true;
      let paramsData = Object.assign(values, params);
      const { code, message } = await http("simOrder", paramsData);
      this.noClick = false;
      if (code == 200) {
        this.dialogTips = {
          text: "提交成功，请留意快递信息，收到的手机号必须与您选择的号码一致，不一致将无法享受套餐相应优惠或活动赠送礼品，如发现号码不一致，请立即联系在线客服处理",
          icon: "success",
          iconColor: "#07C160",
          show: true,
          confirmButtonText: "确定",
        };
      } else {
        this.dialogTips = {
          text: message,
          icon: "warning",
          iconColor: "#FF4444",
          show: true,
          confirmButtonText: "关闭",
        };
      }
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY >= this.showBtnTop) {
        if (!this.bottomBtn) {
          this.bottomBtn = true;
        }
      } else {
        if (this.bottomBtn) {
          this.bottomBtn = false;
        }
      }
      // console.log("Scroll Y position:", this.scrollY);
    },
    selcetNum(item) {
      this.comboMobile = item;
      this.showMobilePicker = false;
    },
    selectCity(values, indexs) {
      // console.log("value =>",value)
      // this.cardAttribution = value.text;
      // this.cardAttributionProvince = value.value;

      this.areaData2 = {
        pName:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
      };
      this.cardAttribution = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.showPicker = false;
    },
    onConfirm(values, indexs) {
      this.areaData = {
        pName:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
        aName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].text
            : "", //区
        aCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].code
            : "",
      };
      console.log("areaData =>", this.areaData);
      this.contactsCity = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      // this.mapData = values;
      this.showArea = false;
    },
    sfzValidator(val) {
      return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        val
      );
    },

    async numGuessSelect() {
      if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货地址");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }

      let params = {
        spiId: this.spiId,
        cityCode: this.cardAttributionCode,
        goodsId: this.tcList[this.selIndex].comboCode,
        provinceCode: this.cardAttributionProvince,
      };
      const { code, result, message } = await http(
        "simNumGuessSelect",
        params
      );
      if (code !== 200) return this.$toast(message);
      if (code == 200) {
        console.log("result =>", result);
        this.numList = result;
        this.showMobilePicker = true;
      }
    },
    initAreaList2() {
      // 由于 cardAreaData 已经是扁平结构，直接使用
      this.areaList2 = [
        {
          text: "",
          code: "0",
          children: this.cardAreaData.children.map(city => ({
            text: city.text,
            code: city.code
          }))
        },
      ];
    },
    toUnicomDeal(components) {
      this.$router.push({
        name: components,
      });
    },
    getCard() {
      const queryData = Object.assign({}, this.swiperMsg, {
        spiId: this.spiId,
        mtBmUid: this.mtBmUid,
      });
      delete queryData.abstractImg;
      this.$router.push({
        name: "GuangzhouUHanding",
        query: queryData,
      });
    },
    handleCitySelect(city) {
      console.log("city =>", city);

      this.areaData2 = {
        pName: "广东",
        pCode: "440000",
        cName: city.text,
        cCode: city.code
      };

      // 根据城市代码跳转到对应页面
      if (this.areaData2.cCode == "440300") {
        window.location.href = "/?activityId=303001&openId=" + this.mtBmUid + "&channel=" + this.channel;
        return;
      }

      if (this.areaData2.cCode == "440400") {
        window.location.href = "/?activityId=301001&openId=" + this.mtBmUid + "&channel=" + this.channel;
        return;
      }

      if (this.areaData2.cCode == "440600") {
        window.location.href = "/?activityId=305001&openId=" + this.mtBmUid + "&channel=" + this.channel;
        return;
      }

      if (this.areaData2.cCode == "441900") {
        window.location.href = "/?activityId=309001&openId=" + this.mtBmUid + "&channel=" + this.channel;
        return;
      }

      // 如果选择的是广州市，不跳转，直接设置归属地
      this.cardAttribution = city.text;
      this.cardAttributionCode = city.code;
      this.cardAttributionProvince = "440000";
      this.comboMobile = ""; // 清空已选号码
      this.showAttributionPicker = false;
    }
  },
};
</script>

<style lang="less" scoped>
@import "../assets/style/GuangzhouUnicom.less";
.small {
  font-size: 10px;
  color: #666;
}
.pBottom {
  padding-bottom: 3px;
}
.textIndent {
  padding-left: 10px;
}

.act {
  .content {
    .contentBox1 {
      .tcInfo {
        .tcInfoBox {
          padding-bottom: 50px;
        }
      }
    }
  }
  .container {
    .content {
      padding: 5px;
      .zfxqTable2 {
        border: 1px solid #799ffd;
        border-radius: 10px;
        .zTr {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #799ffd;
          &:last-child {
            border-bottom: none;
          }
          .zTh {
            padding: 10px;
            box-sizing: border-box;
            color: #3e5fb2;
            text-align: center;
            font-size: 14px;
            width: 30%;
            font-weight: bold;
          }
          .zTd {
            width: 70%;
            box-sizing: border-box;
            border-left: 1px solid #799ffd;
            font-size: 13px;
            .blueText {
              color: #3e5fb2;
              font-weight: 600;
              font-size: 16px;
            }
            .zTCBox {
              display: flex;
              justify-content: space-between;
              &.bTop {
                border-top: 1px solid #3074da;
              }
              .zTCItem {
                width: 25%;
                border-right: 1px solid #3074da;
                padding: 20px 5px;
                box-sizing: border-box;
                text-align: center;
                font-size: 12px;
                &.thText {
                  font-weight: 500;
                  color: #3e5fb2;
                }
                &:last-of-type {
                  border: none;
                }
                &.w100 {
                  width: 100%;
                }
                &.textL {
                  text-align: left;
                  padding-left: 20px;
                  .smallText {
                    padding: 5px;
                  }
                }
                &.bigPadding {
                  padding: 35px 0;
                }
                .smallText {
                  padding: 5px 0;
                }
              }
            }
          }
        }
      }
      .zfxqTable3 {
        border: 1px solid #799ffd;
        border-radius: 10px;
        .zTr {
          display: flex;
          align-items: stretch;
          border-bottom: 1px solid #799ffd;
          &:last-child {
            border-bottom: none;
          }
          .zTh, .zTd, .z3Td {
            padding: 8px 10px;
            margin: 0;
            box-sizing: border-box;
            font-size: 13px;
            line-height: 1.5;
            vertical-align: middle;
            font-weight: normal;
          }
          .zTh {
            color: #3e5fb2;
            text-align: center;
            font-size: 12px;
            width: 20%;
            font-weight: bold;
          }
          .zTd {
            width: 40%;
            border-left: 1px solid #799ffd;
            .blueText {
              color: #3e5fb2;
              font-size: 15px;
              line-height: 1.5;
              margin: 0;
              padding: 0;
              display: inline;
            }
            .blueText2 {
              color: #3e5fb2;
              font-size: 16px;
              line-height: 1.5;
              margin: 0;
              padding: 0;
              display: inline;
              font-weight: bold;
            }
          }
          .z3Td {
            width: 80%;
            border-left: 1px solid #799ffd;
            font-size: 13px;
            padding: 10px;
            .blueText {
              color: #3e5fb2;
              font-size: 14px;
              line-height: 1.5;
              margin: 0;
              padding: 0;
              display: inline;
            }
          }
        }
      }
    }
  }
}

.tcBox {
  padding: 10px 0;
  // padding-bottom: 20px;
  .topBox {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 0 20px;
    .close {
      color: #969799;
      padding: 15px;
    }
    .define {
      color: #576b95;
      padding: 10px;
    }
    .title {
      font-size: 18px;
      padding: 15px;
    }
  }
  .content {
    .tcItem {
      border-bottom: 1px solid #eee;
      padding: 10px 0;
      font-size: 16px;
      text-align: center;
      box-sizing: border-box;
      &:last-child {
        border: none;
      }
      &.active {
        color: #3074da;
      }
    }
  }
}

.spiImg {
  width: 100%;
  border-radius: 10px;
}

.highlight {
  background-color: #fff8e6;
  color: #ff6b00;
  padding: 3px;
  border-radius: 4px;
  font-weight: 700;
  border-left: 4px solid #ff6b00;
}

.container .header2 {
  background-size: cover;
  background-position: center;
  text-align: left;
  font-size: 22px;
  font-weight: bold;
  color: #3e5fb2;
  border-radius: 10px 10px 0 0;
  box-sizing: border-box;
  height: 30px;
  padding-left: 20px;
  padding-top: 7px;
}

.attribution-dialog {
  :deep(.van-dialog) {
    border-radius: 16px;
    overflow: hidden;
    width: 80%;
    max-width: 320px;
  }
  
  :deep(.van-dialog__header) {
    padding: 20px 16px;
    font-size: 18px;
    color: #333;
    border-bottom: 1px solid #f5f5f5;
    text-align: center;
  }

  .attribution-content {
    padding: 20px 16px;
    
    .city-list {
      display: flex;
      flex-direction: column;
      gap: 12px;
      
      .city-item {
        height: 44px;
        line-height: 44px;
        text-align: center;
        background: #0858a7;
        border-radius: 8px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
          background: #e8f0fe;
          color: #3074da;
        }
        
        &:active {
          transform: scale(0.98);
        }
      }
    }
  }
}
</style>
